module.exports = __webpack_public_path__ + "static/media/anc2kz.b1912a13.pdf";